import { TabState, TAB_STATE } from '../../constants/jobSearchDetailTab';
import { QueryParams } from '../../constants/queryParams';
import { DODA_SITE_URL } from '../../constants/urls';
import { makeStaticUrl } from '../staticUrl';

/**
 * タブに設定するURLの生成
 * @param {QueryParams} queryParams URLのクエリ
 * @param {TabState} tabState 対象のタブ
 * @param {string | undefined} seminarTitleId セミナータイトルID
 * @returns {string} url
 */
export const createTabUrl = (
  queryParams: QueryParams,
  tabState: TabState,
  seminarTitleId?: string
) => {
  const {
    jid,
    tp,
    bnid,
    osscfl,
    scoutlist_id,
    message_id,
    ap_id,
    record_scoutlist_id,
    record_message_id,
    recommendID,
    mpsc_sid,
  } = queryParams;

  if (!jid) return undefined;

  switch (tabState) {
    case TAB_STATE.requirement:
    case TAB_STATE.jobdetail: {
      const staticurl = makeStaticUrl(
        {
          jid,
          tab: 'jd',
          fm: 'jobdetail',
          mpsc_sid,
          tp,
          bnid,
          bnnt: bnid ? '1' : undefined,
          osscfl,
          scoutlist_id,
          message_id,
          record_scoutlist_id,
          record_message_id,
          ap_id,
        },
        DODA_SITE_URL.jobSearchDetail
      );
      return staticurl + (recommendID ? `?recommendID=${recommendID}` : '');
    }
    case TAB_STATE.applicationMethod: {
      const staticurl = makeStaticUrl(
        {
          jid,
          tab: 'jd',
          fm: 'jobdetail',
          mpsc_sid,
          tp,
          bnid,
          bnnt: bnid ? '1' : undefined,
          osscfl,
          scoutlist_id,
          message_id,
          record_scoutlist_id,
          record_message_id,
          ap_id,
        },
        DODA_SITE_URL.jobSearchDetail
      );
      return `${staticurl}?tabContent=shtTabContent2${
        recommendID ? `&recommendID=${recommendID}` : ''
      }`;
    }
    case TAB_STATE.pr: {
      const staticurl = makeStaticUrl(
        {
          jid,
          tab: 'pr',
          fm: 'jobdetail',
          tp,
          bnid,
          bnnt: bnid ? '1' : undefined,
          osscfl,
          scoutlist_id,
          message_id,
          record_scoutlist_id,
          record_message_id,
          ap_id,
        },
        DODA_SITE_URL.jobSearchDetail
      );
      return staticurl + (recommendID ? `?recommendID=${recommendID}` : '');
    }
    case TAB_STATE.seminar: {
      const staticurl = makeStaticUrl(
        {
          jid,
          tab: 'seminar',
          fm: 'jobdetail',
          seminargroup_id: seminarTitleId,
          tp,
          bnid,
          bnnt: bnid ? '1' : undefined,
          scoutlist_id,
          message_id,
          record_scoutlist_id,
          record_message_id,
          ap_id,
        },
        DODA_SITE_URL.seminarDetail
      );
      return staticurl;
    }
    case TAB_STATE.photos: {
      const staticurl = makeStaticUrl(
        {
          jid,
          tab: 'jd',
          fm: 'jobdetail',
          mpsc_sid,
          tp,
          bnid,
          bnnt: bnid ? '1' : undefined,
          osscfl,
          scoutlist_id,
          message_id,
          record_scoutlist_id,
          record_message_id,
          ap_id,
        },
        DODA_SITE_URL.jobSearchDetail
      );
      return `${staticurl}?tabContent=shtTabContent3${
        recommendID ? `&recommendID=${recommendID}` : ''
      }`;
    }
    case 'photos_pc': {
      const staticurl = makeStaticUrl(
        {
          jid,
          tab: 'photos',
          fm: 'jobdetail',
          mpsc_sid,
          tp,
          bnid,
          bnnt: bnid ? '1' : undefined,
          osscfl,
          scoutlist_id,
          message_id,
          record_scoutlist_id,
          record_message_id,
          ap_id,
        },
        DODA_SITE_URL.jobSearchDetail
      );
      return staticurl + (recommendID ? `?recommendID=${recommendID}` : '');
    }
    default:
      return undefined;
  }
};
